(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["maa-blog-page"]) return;
  try {
    
  (function () {
    function initAutoLoad(root) {
      var grid = root.querySelector('.maa-blog-page__grid');
      var sentinel = root.querySelector('.maa-blog-page__sentinel');
      if (!grid || !sentinel) return;

      var nextUrl = sentinel.getAttribute('data-next-url') || '';
      if (!nextUrl) {
        sentinel.remove();
        return;
      }

      /* Progressive enhancement: the numbered pagination stays in the markup
         for crawlers and no-JS users; once the auto-loader is running we hide
         it and take over. */
      var nav = root.querySelector('.pagination');
      if (nav) nav.hidden = true;

      var loading = false;
      var seen = Object.create(null);
      grid.querySelectorAll('.blog-card').forEach(function (card) {
        seen[card.getAttribute('href')] = true;
      });

      function stop() {
        observer.disconnect();
        sentinel.remove();
      }

      function fail() {
        /* On any fetch/parse error, fall back to the numbered links. */
        if (nav) nav.hidden = false;
        stop();
      }

      function loadNext() {
        if (loading || !nextUrl) return;
        loading = true;
        sentinel.classList.add('is-loading');

        fetch(nextUrl, { headers: { Accept: 'text/html' } })
          .then(function (res) {
            if (!res.ok) throw new Error('HTTP ' + res.status);
            return res.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fetchedGrid = doc.querySelector('.maa-blog-page__grid');
            if (!fetchedGrid) throw new Error('No grid in fetched page');

            fetchedGrid.querySelectorAll('.blog-card').forEach(function (card) {
              var href = card.getAttribute('href');
              if (seen[href]) return; /* de-duplicate across pages */
              seen[href] = true;
              /* Featured/half layouts only make sense at the top of page 1;
                 appended cards join the grid as standard cards. */
              card.classList.remove('blog-card--featured', 'blog-card--half');
              card.querySelectorAll('img[loading="eager"]').forEach(function (img) {
                img.setAttribute('loading', 'lazy');
              });
              grid.insertBefore(card, sentinel);
            });

            var fetchedSentinel = doc.querySelector('.maa-blog-page__sentinel');
            nextUrl = fetchedSentinel
              ? fetchedSentinel.getAttribute('data-next-url') || ''
              : '';

            loading = false;
            sentinel.classList.remove('is-loading');

            if (!nextUrl) {
              stop();
            } else {
              /* Re-observing re-delivers the current intersection state, so if
                 the sentinel is still in view the next page loads immediately. */
              observer.unobserve(sentinel);
              observer.observe(sentinel);
            }
          })
          .catch(function () {
            loading = false;
            sentinel.classList.remove('is-loading');
            fail();
          });
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) loadNext();
          });
        },
        { rootMargin: '400px 0px' }
      );

      /* The sentinel sits inside the grid so appended cards land before it. */
      grid.appendChild(sentinel);
      observer.observe(sentinel);
    }

    function init() {
      document
        .querySelectorAll('.maa-blog-page[data-auto-load="true"]')
        .forEach(initAutoLoad);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
